 
 
 
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import {
    getProductListDataView,
    getProductListDataViewProperty,
} from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import PanelMenu, { PanelMenuPresentationProps, PanelMenuProps } from "@insite/mobius/PanelMenu";
import PanelRow, { PanelRowPresentationProps } from "@insite/mobius/PanelMenu/PanelRow";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductListInStockSection from "@tCentro/Components/CENProductListInStockSection";
import ArrowLeftIcon from "@tCentro/Icons/ArrowLeftIcon";
import ArrowRightIcon from "@tCentro/Icons/ArrowRightIcon";
import NISFilterIcon from "@tCentro/Icons/NISFilterIcon";
import SearchIcon from "@tCentro/Icons/SearchIcon";
import { DrawerProps } from "@tCentro/MobiusOverrides/Drawer";
import ProductListSearchWithin from "@tCentro/Overrides/Widgets/ProductList/ProductListSearchWithin";
import ProductListStockedItemsFilter from "@tCentro/Overrides/Widgets/ProductList/ProductListStockedItemsFilter";
import { COLORS, NISCO, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    title: string;
    facets: FacetModel[];
    onChangeFacet: (facet: FacetModel) => void;
}
const mapStateToProps = (state: ApplicationState) => {
    const attributeTypeFacets = getProductListDataViewProperty(state, "attributeTypeFacets");
    const pagination = getProductListDataViewProperty(state, "pagination");
    const {
        pages: {
            productList: { productFilters },
        },
    } = state;
    return {
        attributeTypeFacets: getProductListDataViewProperty(state, "attributeTypeFacets"),
        pageBrandId: state.pages.productList.productFilters.pageBrandId,
        loaded: !!getProductListDataView(state).value,
        productFilters: state.pages.productList.productFilters,
        totalItemCount: pagination?.totalItemCount,
        stockedItemsOnly: productFilters.stockedItemsOnly ?? false,
        previouslyPurchasedProducts: productFilters.previouslyPurchasedProducts ?? false,
        searchWithinQueries: productFilters.searchWithinQueries,
        selectedBrandIds: productFilters.brandIds,
        selectedProductLineIds: productFilters.productLineIds,
        selectedPriceFilters: productFilters.priceFilters,
        selectedAttributeValuesIds: productFilters.attributeValueIds,
        selectedCategoryId: productFilters.categoryId,
        siteName: state.context.website.name,
    };
};

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
    clearAllProductFilters,
};
type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface ProductListFiltersDrawerStyles {
    filterBtnStyles?: InjectableCss;
    filterActiveBtnStyles?: InjectableCss;
    drawerStyles?: DrawerPresentationProps;
    showResultsStyles?: InjectableCss;
    filterCount?: InjectableCss;
    filterIcon?: IconPresentationProps;
}

export const productListFiltersDrawerStyles: ProductListFiltersDrawerStyles = {
    filterBtnStyles: {
        css: css`
            padding: 8px 16px;
            border-radius: 2px;
            background: transparent;
            border-color: ${NISCO.COLORS.primaryColor};
            color: ${NISCO.COLORS.primaryColor};
            font-family: ${NISCO.TYPOGRAPHY.fontFamily.title};
            text-transform: uppercase;
            text-align: center;
            vertical-align: middle;
            line-height: 16px;
            font-size: ${TYPOGRAPHY.size.base};
            font-weight: ${TYPOGRAPHY.weight.bold};
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0;
            float: right;
            width: 181px;
            &:hover {
                background: transparent;
                border-color: ${NISCO.COLORS.primaryColor};
                color: ${NISCO.COLORS.primaryColor};
            }
        `,
    },
    filterActiveBtnStyles: {
        css: css`
            padding: 8px 16px;
            border-radius: 2px;
            background: transparent;
            border-color: ${NISCO.COLORS.primaryColor};
            color: ${NISCO.COLORS.primaryColor};
            font-family: ${NISCO.TYPOGRAPHY.fontFamily.title};
            text-transform: uppercase;
            text-align: center;
            vertical-align: middle;
            line-height: 16px;
            font-size: ${TYPOGRAPHY.size.base};
            font-weight: ${TYPOGRAPHY.weight.bold};
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0;
            float: right;
            width: 181px;
            &:hover {
                background: ${NISCO.COLORS.primaryColor};
                border-color: ${NISCO.COLORS.primaryColor};
                color: ${NISCO.COLORS.primaryColor};
            }
        `,
    },

    drawerStyles: {
        size: 350,
        cssOverrides: {
            drawerBody: css`
                background: ${COLORS.white} !important;
            `,
            drawerContent: css`
                nav {
                    border-bottom: 1px solid #bcc3cd;
                    padding: 20px 18px 20px 16px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-bottom: 60px;
                        `,
                        css`
                            margin-bottom: 60px;
                        `,
                        css`
                            margin-bottom: 60px;
                        `,
                        null,
                        null,
                    ])}
            `,
            drawerTitle: css`
                border-bottom: 1px solid #bcc3cd;
                height: 80px;
                button {
                    margin-top: 12px;
                }
                `,
                headlineTypography: css`
                font-size: 24px !important;
                font-weight: 600 !important;
                line-height: 32px !important;
                margin-left: 16px !important;
                margin-top: 15px !important;
                color: ${NISCO.COLORS.primaryColor} !important;
                margin-bottom: 0 !important;
            `,
        },
    },

    showResultsStyles: {
        css: css`
            display: flex;
            justify-content: center;
            gap: 10px;
            width: 100%;
            height: 32px;
            position: absolute;
            bottom: 10px;
            right: 0;
            border-radius: 24px;
        `,
    },

    filterCount: {
        css: css`
            display: inline;
        `,
    },

    filterIcon: {
        size: 20,
        css: css`
            margin-right: 8px;
        `,
    },
};

const styles = productListFiltersDrawerStyles;

const NISProductListMobileFiltersPanel: FC<Props> = ({
    attributeTypeFacets,
    addProductFilters,
    totalItemCount,
    id,
    stockedItemsOnly,
    previouslyPurchasedProducts,
    searchWithinQueries,
    selectedBrandIds,
    selectedProductLineIds,
    selectedPriceFilters,
    selectedAttributeValuesIds,
    selectedCategoryId,
    clearAllProductFilters,
    siteName,
}) => {
    const [filterDrawerIsOpen, setFilterDrawerIsOpen] = useState(false);

    const clickFilterIconHandler = () => {
        setFilterDrawerIsOpen(!filterDrawerIsOpen);
    };

    const filterDrawerCloseHandler = () => {
        setFilterDrawerIsOpen(false);
    };

    const clearAllProductFiltersHandler = () => {
        clearAllProductFilters();
        setFilterDrawerIsOpen(false);
    };

    const appliedFiltersCount =
        (stockedItemsOnly ? 1 : 0) +
        (previouslyPurchasedProducts ? 1 : 0) +
        (searchWithinQueries?.length || 0) +
        (selectedBrandIds?.length || 0) +
        (selectedProductLineIds?.length || 0) +
        (selectedPriceFilters?.length || 0) +
        (selectedAttributeValuesIds?.length || 0) +
        (selectedCategoryId ? 1 : 0);

    const itemsText = totalItemCount !== 1 ? " Results" : " Result";
    const numberFormatter = Intl.NumberFormat("en-US");
    const formattedTotalItemCount = numberFormatter.format(totalItemCount ?? 0);

    return (
        <Hidden above="lg">
            <Button
                onClick={clickFilterIconHandler}
                {...(appliedFiltersCount > 0 ? styles.filterActiveBtnStyles : styles.filterBtnStyles)}
            >
                <Icon src={NISFilterIcon} {...styles.filterIcon} />
                <Typography as="p">{translate("Sort & Filter")}</Typography>

                <Hidden {...styles.filterCount}>
                    <span>{appliedFiltersCount > 0 && `(${appliedFiltersCount})`}</span>
                </Hidden>
            </Button>
            <Drawer
                position="right"
                handleClose={filterDrawerCloseHandler}
                isOpen={filterDrawerIsOpen}
                {...styles.drawerStyles}
                headline={`${translate('Filters')} ${formattedTotalItemCount} ${translate(itemsText)}`}
            >
                <Zone contentId={id} zoneName="DrawerContent"></Zone>
                <StyledWrapper {...styles.showResultsStyles}>
                    <Button onClick={filterDrawerCloseHandler} id="show-filtered-results">
                        Show {totalItemCount} Results
                    </Button>
                    <Button onClick={clearAllProductFiltersHandler}>Clear All</Button>
                </StyledWrapper>
            </Drawer>
        </Hidden>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(NISProductListMobileFiltersPanel),
    definition: {
        group: "Product List",
        displayName: "NIS Mobile Filter Panel",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
